import { render, staticRenderFns } from "./MyFinishedForm.vue?vue&type=template&id=ca8a94c6&"
import script from "./MyFinishedForm.vue?vue&type=script&lang=js&"
export * from "./MyFinishedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca8a94c6')) {
      api.createRecord('ca8a94c6', component.options)
    } else {
      api.reload('ca8a94c6', component.options)
    }
    module.hot.accept("./MyFinishedForm.vue?vue&type=template&id=ca8a94c6&", function () {
      api.rerender('ca8a94c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/modules/MyFinishedForm.vue"
export default component.exports